import { Component, Input } from "@angular/core";

@Component({
  selector: 'sigecom-chip-tag',
  template: `
    <div
      class="flex text-nowrap items-center font-semibold px-4 py-1 rounded-full border"
      [ngClass]="{
        'text-emerald-500 border-emerald-500 bg-emerald-500/10':
          status == TagStatusEnum.CONCLUIDO,
        'text-yellow-500 border-yellow-500 bg-yellow-500/10':
          status ==TagStatusEnum.EM_PROCESSAMENTO,
        'text-yellow-400 border-x-yellow-400 bg-yellow-400/10':
          status ==TagStatusEnum.PENDENTE,
        'text-red-500 border-red-500 bg-red-500/10':
          status ==TagStatusEnum.CANCELADO,
        class : class
      }"
    >{{text}}</div>
  `,
})

export class ChipTagComponent {
  @Input() status: TagStatusEnum = TagStatusEnum.CONCLUIDO;
  @Input() text: string = "Concluído";
  @Input() class?: string;
  TagStatusEnum = TagStatusEnum;
}
export enum TagStatusEnum{
  CONCLUIDO = 'CONCLUIDO',
  EM_PROCESSAMENTO = 'EM_PROCESSAMENTO',
  PENDENTE = 'PENDENTE',
  CANCELADO = 'CANCELADO',

}
